var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplaneIconOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50038 9.99975L3.22461 2.60352C8.73722 4.20489 13.8569 6.72976 18.4052 9.99954C13.857 13.2694 8.73728 15.7943 3.22469 17.3957L5.50038 9.99975ZM5.50038 9.99975L11.7506 9.99976",
    stroke: "#9A9AAF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneIconOutline);
export default __webpack_public_path__ + "static/media/airplaneIconOutline.3817b2f5ce7a2c570adf3cddddf10e72.svg";
export { ForwardRef as ReactComponent };